import {
  DropdownMenu,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu.tsx';
import TableButtonMock from '@/components/buttons/TableButtonMock.tsx';
import { Funnel } from 'lucide-react';
import React, { useState } from 'react';
import { useTableStoreContext } from '@/components/table/contexts/TableContext.tsx';
import FilterOptionsDropdown from '@/components/table/components/filter/FilterOptionsDropdown.tsx';

const FilterAction = () => {
  const [open, setOpen] = useState(false);
  const tableDefinition = useTableStoreContext(
    (state) => state.tableDefinition,
  );

  return (
    <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>
      <DropdownMenuTrigger>
        <FilterButton />
      </DropdownMenuTrigger>
      {tableDefinition.fields && tableDefinition.fields.length > 0 && (
        <FilterOptionsDropdown
          tableDef={tableDefinition}
          onClose={() => setOpen(false)}
        />
      )}
    </DropdownMenu>
  );
};

const FilterButton = () => {
  const filterCriteria = useTableStoreContext((state) => state.filterCriteria);

  return (
    <TableButtonMock isActive={filterCriteria.filters.length > 0}>
      <Funnel />
      {filterCriteria.filters.length > 0 && (
        <span className="rounded-[2px] bg-basic-white px-1">
          {filterCriteria.filters.length}
        </span>
      )}
      Filtruj
    </TableButtonMock>
  );
};

export default FilterAction;
